<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">Taste of Honey</h1>
<h2 class="center" id="heading_id_2">A Carson Springs Novel (Book Two)</h2>
<h3 class="center" id="heading_id_3" style="margin-top:80px;">Eileen Goudge</h3>
<p class="center" style="margin-top:80px;"><span><img alt="Description: img" src="Images/logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?6716ce95